module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "CHAPTER1",
    attrs: {
      "id": "u94uMWPCBwXZy5eQ4XxULMB",
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Basic_Bold"
  }, [_c('a', {
    attrs: {
      "id": "urFti6jySCtcvzYEHQ3YmS2"
    }
  }), _vm._v("CHAPTER 1")])]), _vm._v(" "), _c('p', {
    staticClass: "CHAPTER2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Basic_Bold"
  }, [_vm._v("THE BERKSHIRES")])]), _vm._v(" "), _c('p', {
    staticClass: "FIRSTPARAGRAPH",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("At the westernmost end of Massachusetts lies Berkshire County, 900 square miles, population somewhere between 150,000 and 155,000 (varying over the years), thirty towns, and two cities. The Berkshires, glorious in nature’s beauty, have a rich history of industrial innovation, of the settlement of one of the longest lasting religious utopian sects, and as a magnet for the ultrawealthy.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("In the early 1900s, the county’s natural resources and rail access from New York and Boston made it ideal for burgeoning industries such as paper, iron, textiles, and spinning and weaving. The Housatonic River provided the power needed for the rapidly growing number of paper mills, an industry that survived in the Berkshires for two hundred years.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The Shakers, originally from England, migrated to the Albany, New York area in the late 1770s. The Shakers, short for Shaking Quakers because of their charismatic worshipping style, believed in pacifism and egalitarianism of the sexes. A celibate society, their numbers increased strictly through recruiting new followers, proselytizing members who wanted to live with this egalitarian, communal, religious utopian sect. In the 1780s, a member of the sect donated farmland in Hancock, Massachusetts, thus establishing an ideal environment for the third of what would become nineteen Shaker communities in the United States.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The Shakers maintained a self-sufficient community that was exemplary in its governance and its contributions to 19th-century society. They made significant contributions in the areas of architecture, education, agriculture, science, medicine, and craftsmanship. Their influence in architecture and furniture style remains popular to this day.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Post-Civil War American industrialists accumulated great wealth. These "), _c('span', {
    staticClass: "Basic_italics"
  }, [_vm._v("nouveau riche")]), _vm._v(" magnates, many from New York and Boston, discovered the beauty of the Berkshire Hills, choosing to build seasonal retreats in this picturesque corner of Massachusetts. The upper crust crowd moved within their social circle, with various homes built in the most favorable locations to enjoy the changing seasons, each competing for the most scenic views.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The estates and mansions built by the likes of Vanderbilt, J.P. Morgan, Stokes, Choates, author Edith Wharton, and sculptor Daniel Chester French were designed in the fashion of European grandeur—an Italian villa, a French palace, or an English estate. Hundreds of craftsmen, artisans, and horticulturists were commissioned to work their magic, creating exquisite structures with magnificent grounds. Laborers by the hundreds, many of them immigrants, provided the workforce and household staffing. With the influx of these estates came the great economic class divide between the very wealthy and their servants, laborers, factory workers, and farmers.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The Berkshires abounded with pride as the birthplace and home of great thinkers and social activists: jurist and legal scholar Oliver Wendell Holmes, advocate for women’s rights Susan B. Anthony, and historian and civil rights activist W.E.B. Dubois. These environs nurtured the creative muse of great American writers Nathaniel Hawthorne, Edith Wharton, and Herman Melville. As Melville gazed out the window of his home, Arrowhead, at the distant Mount Greylock, the contours of the landscape reminded him of a humped back of a sperm whale, thus inspiring the novel "), _c('span', {
    staticClass: "Basic_italics"
  }, [_vm._v("Moby Dick.")]), _vm._v(" Nathanial Hawthorne wrote "), _c('span', {
    staticClass: "Basic_italics"
  }, [_vm._v("The House of Seven Gables ")]), _vm._v("and his series of children’s stories "), _c('span', {
    staticClass: "Basic_italics"
  }, [_vm._v("Tanglewood Tales")]), _vm._v(" in his little red cottage in Stockbridge.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The arts flourished with world renowned cultural venues such as Tanglewood (summer home of the Boston Symphony Orchestra), Jacob’s Pillow Dance Festival, Williamstown Theater Festival, the Sterling and Francine Clark Art Institute, Shakespeare and Company, the Berkshire Theater Festival, the Norman Rockwell Museum, Chesterwood (home and studio of sculptor Daniel Chester French), the Berkshire Museum, and Hancock Shaker Village, along with the restoration of some of the great estates of the 1800s.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Nestled in the scenic and tranquil Berkshire Hills lies the larger of the two cities—Pittsfield. Forty-three square miles with a population of between 50,000 and 35,000 (varying over the years), Pittsfield boasted of being a wonderful place to raise a family with the local Bousquet ski mountain, beautiful Onota and Pontoosuc Lakes, parks, hiking trails, and Wahconah Park baseball stadium, one of the oldest stadiums dating back to 1919. Built with home plate facing west into the blinding, setting sun, action at this vintage wooden baseball stadium routinely pauses for sun delays, adding to the stadium’s quirky charm.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Despite the beauty and charm of this New England city, changes were happening. In1982, Massachusetts passed Proposition 2 ½, an initiative spearheaded by Citizens for Limited Taxation. This law limited municipal governments from increasing assessed property taxes to no more that 2.5% each year. Although a triumph for anti-tax advocates, local government coffers felt the pinch."), _c('span', {
    staticClass: "Footnote-reference _idGenCharOverride-3"
  }, [_c('span', {
    attrs: {
      "id": "footnote-002-backlink"
    }
  }, [_c('a', {
    staticClass: "_idGenColorInherit",
    attrs: {
      "href": "#/Text/Chap_01#footnote-002"
    }
  }, [_vm._v("1")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The ‘80s also brought the disastrous shutdown of General Electric’s transformer division. GE’s arrival in Pittsfield in 1907 revived the old mill town economy of the 19th century. In a city of 50,000 at its height in the 1940s, GE employed 13,000. Pittsfield gave itself over to its one mega-industry. The GE workers were paid well, received generous benefits, living and working as a close-knit community. The company’s benevolence and community involvement were legendary. After eighty years GE swept out of town, leaving PCB contamination in its wake. Pyranol, a coolant used in the manufacturing of small transformers, was later discovered to be a dangerous carcinogen."), _c('span', {
    staticClass: "Footnote-reference _idGenCharOverride-3"
  }, [_c('span', {
    attrs: {
      "id": "footnote-001-backlink"
    }
  }, [_c('a', {
    staticClass: "_idGenColorInherit",
    attrs: {
      "href": "#/Text/Chap_01#footnote-001"
    }
  }, [_vm._v("2")])])]), _c('span', {
    staticClass: "Basic_Bold"
  }), _vm._v("It is estimated that one and a half million pounds of PCBs were leaked or dumped into the Housatonic River. PCB laden soil was even donated to Berkshire County cities and towns as clean landfill."), _c('span', {
    staticClass: "Footnote-reference _idGenCharOverride-3"
  }, [_c('span', {
    attrs: {
      "id": "footnote-000-backlink"
    }
  }, [_c('a', {
    staticClass: "_idGenColorInherit",
    attrs: {
      "href": "#/Text/Chap_01#footnote-000"
    }
  }, [_vm._v("3")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The trickle down effected the entire local economy. Pittsfielders, who had once flocked to North Street aka “upstreet” to shop, found their favorite stores closing or moving away. Hoping to revitalize the downtown’s main drag with a shopping mall just did not cut it with the locals and the plan never happened.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Yes, things were changing. Pittsfield was a shrinking city, struggling to redefine itself. As this quiet city came to life in the early morning hours of a typical, snowy Berkshires winter day, January 7, 1994, Pittsfield was about to put itself back on the map.")]), _vm._v(" "), _c('hr', {
    staticClass: "HorizontalRule-1"
  }), _vm._v(" "), _c('div', [_c('div', {
    attrs: {
      "id": "footnote-002"
    }
  }, [_c('p', {
    staticClass: "Footnote-text",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    staticClass: "_idGenColorInherit",
    attrs: {
      "href": "#/Text/Chap_01#footnote-002-backlink"
    }
  }, [_vm._v("1")]), _vm._v(". "), _c('span', {
    staticClass: "Basic_Bold"
  }, [_vm._v("Proposition 2 ½ (")]), _c('span', {
    staticClass: "Basic_Bold-Italics"
  }, [_vm._v("Wikipedia—https//en.wikipedia.org/wiki/Proposition 2 1/2).")])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "footnote-001"
    }
  }, [_c('p', {
    staticClass: "Footnote-text",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    staticClass: "_idGenColorInherit",
    attrs: {
      "href": "#/Text/Chap_01#footnote-001-backlink"
    }
  }, [_vm._v("2")]), _vm._v(". "), _c('span', {
    staticClass: "Basic_Bold"
  }, [_vm._v("GE Left Behind a Complex Legacy in Pittsfield, How PCBs Came to be Used and Leaked (http://www.wbur.org/radioboston/2016/06/29/ge-andpittsfield).")])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "footnote-000"
    }
  }, [_c('p', {
    staticClass: "Footnote-text",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    staticClass: "_idGenColorInherit",
    attrs: {
      "href": "#/Text/Chap_01#footnote-000-backlink"
    }
  }, [_vm._v("3")]), _vm._v(". "), _c('span', {
    staticClass: "Basic_Bold"
  }, [_vm._v("www.thebeatnews.org/BeatTeam/pcbs-dumped/).")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d68a2a48","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Chap_01.vue
// module id = 81
// module chunks = 0